import { AppModal } from '../common';
import { SelfList, SelfListProps } from '../reserve/Self';
import { useSelfContext } from '@/context';

export interface SelfListModalProps extends AppModalProps, SelfListProps {
  onSelect?: (self: SelfEntity) => void;
}

export function SelfListModal({
  open,
  hide,
  onSelect,
}: SelfListModalProps) {

  const { selfText, currentSelfItems } = useSelfContext();

  if (currentSelfItems.length === 1) return <></>;

  return (
    <AppModal
      footer={null}
      width={700}
      open={open}
      onCancel={hide}
      destroyOnHidden
      style={{ maxWidth: '90%' }}
      title={selfText('choose-self-title')}
    >
      <SelfList onSelect={onSelect} />
    </AppModal>
  );
};

export default SelfListModal;
